import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import EnvVars from "../../helpers/EnvVars";

interface RouteParams {
  uuid: string;
}

const OldPublicAwarenessScreen: React.FC = () => {
  const { uuid } = useParams<RouteParams>();

  useEffect(() => {
    window.location.replace(
      `${EnvVars.API_GATEWAY_URL}/awareness_screens/${uuid}/html`
    );
  }, [uuid]);

  return null;
};

export default OldPublicAwarenessScreen;
